
import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table';

interface RechargesTabProps {
  recharges: any[];
  date?: Date;
}

export const RechargesTab: React.FC<RechargesTabProps> = ({ recharges, date }) => {
  const { t } = useTranslation();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  if (recharges.length === 0) {
    return (
      <div className="text-center py-6 text-muted-foreground">
        {date ? 
          t('history.noRechargesDate', { date: format(date, 'dd/MM/yyyy') }) : 
          t('history.noRecharges')}
      </div>
    );
  }

  return (
    <div className="max-h-[50vh] overflow-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t('history.fields.amount')}</TableHead>
            <TableHead>{t('history.fields.date')}</TableHead>
            <TableHead>{t('history.fields.code')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {recharges.map((recharge: any, index: number) => (
            <TableRow key={index}>
              <TableCell>{recharge.amount} DJF</TableCell>
              <TableCell>{formatDate(recharge.date)}</TableCell>
              <TableCell>{recharge.cardnumbers}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
